<template>
  <!-- Error dialog with form errors-->
    <nx-dialog v-if="scopes.length > 0"
               :value="visible"
               @input="$emit('close')"
               :title="title"
               :icon="icon"
               max-width="600px">
      <nx-table class="mb-4" :scopes="scopes" v-slot="{ items, scope }">
          <nx-table-item v-for="(item, index) in items"
                         :key="`${scope}-${index}`"
                         :title="item.msg"
                         actionable
                         @click="scrollToField(item)"
                         icon="east"/>
      </nx-table>
      <template slot="actions">
        <v-btn flat color="secondary" @click="$emit('close')" v-text="$t('message.common.close')" />
      </template>
    </nx-dialog>
</template>

<script>
import NxTable from '@/components/table/Table';
import NxTableItem from '@/components/table/TableItem';
import NxDialog from '@/components/dialogs/Dialog';

export default {
  name: 'nx-form-error-dialog',
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  components: {
    NxDialog,
    NxTableItem,
    NxTable,
  },
  props: {
    visible: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    scopes: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    scrollTo(target) {
      const element = document.getElementById(target);
      if (!target) {
        return;
      }

      const isVisible = !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
      if (!isVisible) {
        // Hidden element, maybe collapsed. Scroll to parent container
        const parentTarget = target.split('/')[0];
        this.scrollTo(parentTarget);
        return;
      }

      const options = {
        duration: 1000,
        offset: element.getBoundingClientRect().y < window.scrollY ? 132 : 80,
      };

      const $editor = this.$getParentEditor();
      if ($editor && $editor.modal) {
        options.container = this.$el.closest('.dialog-body');
      }

      this.$vuetify.goTo(element, options);
    },
    scrollToField({ scope, field }) {
      return this.scrollTo(`form-field-${scope}-${field}`);
    },
  },
};
</script>
